import { Box, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { palette } from '@ahora-patagonia/design-tokens';

export interface EncabezadoBloqueProps {
  nombre: string;
  /** Destino de "Ver todo". Sin esto no se dibuja: la portada no tiene a dónde ir. */
  verTodo?: string;
}

/**
 * Nombre del bloque + regla de 2 px + "Ver todo", y nada más: los chevrones del bloque paginado
 * viven en las columnas laterales del riel, no acá. El rótulo de origen del handoff
 * ("Automática · orden intervenible") es metadato para la redacción y **no se dibuja
 * nunca** en el sitio, en ningún corte.
 */
export function EncabezadoBloque({ nombre, verTodo }: EncabezadoBloqueProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: 1,
        borderBottom: `2px solid ${palette.ink}`,
        pb: 0.5,
        mb: 1.5,
      }}
    >
      <Typography variant="tituloBloque" component="h2" sx={{ minWidth: 0 }}>
        {nombre}
      </Typography>
      {verTodo && (
        <MuiLink
          component={RouterLink}
          to={verTodo}
          sx={{
            fontWeight: 800,
            fontSize: 13,
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            display: 'flex',
            alignItems: 'center',
            minHeight: 48,
          }}
        >
          Ver todo
        </MuiLink>
      )}
    </Box>
  );
}
